import fr from './fr.json'
import en from './en.json'

export const defaultLocale = localStorage.getItem('language') || navigator.language.split('-')[0]

export const languages = {
  fr: fr, 
  en: en
} 